<router-outlet>
    <app-spinner></app-spinner>
    <app-loader></app-loader>
</router-outlet>